export const StatusWait = 0
export const StatusClaim = 1
export const StatusConfirm = 2
export const MapStatus = {
  [StatusWait]: {label: '未认领', color: '#5c5c5c', bg_color: '#efeded'},
  [StatusClaim]: {label: '已认领', color: '#FF5733', bg_color: '#FF573333'},
  [StatusConfirm]: {label: '已确认', color: '#009700', bg_color: '#00970033'},
  3: {label: '已撤销', color: '#c6c4c4', bg_color: '#fff'},
}
export const MapClaim = {
  [StatusWait]: {label: '未认领', color: '#5c5c5c', bg_color: '#efeded'},
  [StatusClaim]: {label: '已认领', color: '#FF5733', bg_color: '#FF573333'},
}
export const FieldsSort = [
  {label: '认领时间', field: 'claim_at'},
  {label: '确认时间', field: 'confirm_at'},
  {label: '导入时间', field: 'created_at'},
]
